import { createClient } from '@connectrpc/connect';
import { PursuitPPService } from '../../../../../../gen/ts/mono/projectdata/v1/pursuit_pp_connect';
import { connectTransport } from '../../../lib/connect/transport';
export const pursuitPPClient = createClient(PursuitPPService, connectTransport);
